import styled from '@emotion/styled';
import { media } from '../../services/media';

export const InputCheckbox = styled.span<{ checked: boolean }>`
    display: block;
    position: relative;

    display: inline-block;

    ${media.max('md')} {
        width: 20px;
        min-width: 20px;
        height: 20px;
        border: 1px solid;
    }

    ${media.min('md')} {
        width: 30px;
        min-width: 30px;
        height: 30px;
        border: 2px solid;
    }

    border-radius: 50%;

    /* margin: 0 1ex 0 0; */

    &:after {
        content: '';
        border-right: 2px solid;
        border-bottom: 2px solid;

        ${media.max('md')} {
            width: 8px;
            height: 16px;
            top: -3px;
            left: 8px;
        }

        ${media.min('md')} {
            width: 12px;
            height: 24px;
            top: -6px;
            left: 12px;
        }

        position: absolute;
        transform: rotate(45deg);

        ${(props) => (props.checked ? `opacity: 1` : `opacity: 0`)};

        transition: opacity 0.3s;
    }
`;
